import React from 'react';

const AsLoading = ({ style }) => {
    const animationCSS = () => {
        return {
            __html: '<style>@-webkit-keyframes spinnerAnimation { 0%, 40%, 100% { -webkit-transform: scaleY(0.4) } 20% {-webkit-transform: scaleY(1.0) }} @keyframes sk-spinnerAnimation {    0%, 40%, 100% {        transform: scaleY(0.4);  -webkit-transform: scaleY(0.4);} 20% { transform: scaleY(1.0);              -webkit-transform: scaleY(1.0);  } }  </style >'
        };
    };
    const addAnimationCSS = () => {
        return <div dangerouslySetInnerHTML={animationCSS()} />;
    };

    const showSpinner = () => {
        const spinnerStyle = {
            height: '50%',
            opacity: '0.5',
            top: '25%'
        };
        const spinnerDivStyle = {
            backgroundColor: 'orange',
            opacity: 2,
            height: '100%',
            width: '10%',
            display: 'inline-block',
            margin: 2,
            WebkitAnimation: 'spinnerAnimation  1.2s infinite ease-in-out',
            animation: 'spinnerAnimation  1.2s infinite ease-in-out'
        };

        const rect2Style = {
            WebkitAnimationDelay: '-1.1s',
            animationDelay: '-1.1s'
        };

        const rect3Style = {
            WebkitAnimationDelay: '-1.0s',
            animationDelay: '-1.0s'
        };

        const rect4Style = {
            WebkitAnimationDelay: '-0.9s',
            animationDelay: '-0.9s'
        };

        const rect5Style = {
            WebkitAnimationDelay: '-0.8s',
            animationDdelay: '-0.8s'
        };

        return (
            <div style={spinnerStyle}>
                <div style={{ width: 40 }}></div>
                <div style={spinnerDivStyle}></div>
                <div style={{ ...spinnerDivStyle, ...rect2Style }}></div>
                <div style={{ ...spinnerDivStyle, ...rect3Style }}></div>
                <div style={{ ...spinnerDivStyle, ...rect4Style }}></div>
                <div style={{ ...spinnerDivStyle, ...rect5Style }}></div>
            </div>
        );
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                opacity: 0.5,
                ...style
            }}
        >
            {addAnimationCSS()}
            {showSpinner()}
        </div>
    );
};

export default AsLoading;
